$(document).ready(function(){



  $("input").change(function(){

//    var pot, cbet = 0;

    if ($.isNumeric($("#potsize").val())){
    var pot = parseFloat($("#potsize").val());
    $("#potsize").text(pot);
    }
    else {
     $("#potsize").val("");
    };

    if ($.isNumeric($("#vil_cbet").val())){
    var cbet = parseFloat($("#vil_cbet").val());
    $("#vil_cbet").text(cbet);
    }
    else {
     $("#vil_cbet").val("");
    };


    $("span#span_totalpot").text(pot + cbet);
    $("#span_potsize").text(pot);
    $("span#span_vil_cbet").text(cbet);
    $("#pot_odds_pct").val((calcPotOddsPCT(pot, cbet)).toFixed(2) + "%");
    $("span#span_potodds").text((calcPotOddsPCT(pot, cbet)).toFixed(2) + "%");
    $("span#span_potoddsnum").text((calcPotOdds(pot, cbet)).toFixed(1) + ":1");



  });


  function calcPotOddsPCT(pot, cbet){
    let total = pot + cbet;
    let odds = cbet / (total + (cbet));
    return (odds).toFixed(2)*100;
  };

  function calcPotOdds(pot, cbet){
    let total = pot + cbet;
    return total/cbet;
  };





});
